if (!customElements.get('product-modal-new')) {
  customElements.define('product-modal-new', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      let isModalOpen = this.hasAttribute('open');
      !isModalOpen && super.show(opener);
    }
  });
}
